import {localInstant,businessZone} from '../utils/businessTime';
export const SCHEDULE_KEYS = ['date','time','start','startAt','scheduledAt','end','endAt','endsAt','duration','durationMinutes','serviceDuration','employeeId','workerId','resourceId','assignedEmployeeId','assignedEmployeeIds','employeeIds','workerIds','serviceId','serviceID','employeeNotRequired','assignmentStatus','eventBufferBeforeMinutes','eventBufferAfterMinutes','eventOptions','eventDetails','selectedCharacterIds','selectedExtraIds'];
export const EXCEPTION_KEYS = ['canOverrideBookingConflicts','canBookOutsideWorkingHours'];
export function scheduleSnapshot(booking) {
  if(!booking)return undefined;
  const value=booking.startAt || booking.scheduledAt || booking.start || (booking.date && booking.time ? localInstant(booking.date,booking.time,businessZone(booking)) : null);
  const start=value?.toDate ? value.toDate() : new Date(value || NaN);
  const rawEnd=booking.endAt || booking.end || booking.endsAt;
  const end=rawEnd ? (rawEnd.toDate ? rawEnd.toDate() : new Date(rawEnd)) : new Date(+start+Number(booking.durationMinutes || booking.duration || 30)*60000);
  if(!Number.isFinite(+start)||!Number.isFinite(+end))return undefined;
  return {start:start.toISOString(),end:end.toISOString(),employeeId:booking.employeeId || booking.workerId || booking.resourceId || null};
}
export function scheduleExceptionDetails(error) {
  const details=error?.details || error?.data?.details || error?.error?.details;
  return details?.reason==='schedule-exception-required' ? details : null;
}
export function requestScheduleException(details) {
  return new Promise((resolve,reject)=>{
    const request={details,resolve,reject,handled:false};
    window.dispatchEvent(new CustomEvent('loop:schedule-exception',{detail:request}));
    if(!request.handled)reject(new Error('Vuelve a abrir la agenda para revisar este conflicto.'));
  });
}
export async function withScheduleExceptionApproval(save) {
  let approval;
  // A changed conflict must be presented again, never silently approved by an old reason.
  for(let attempt=0;attempt<4;attempt++) {
    try{return await save(approval);}catch(error){
      const details=scheduleExceptionDetails(error);if(!details)throw error;
      approval=await requestScheduleException(details);
    }
  }
  throw new Error('La agenda está cambiando. Actualiza y vuelve a intentarlo.');
}
